<template>
    <table
        cellspacing="1"
        cellpadding="7"
        border="1"
        summary="This table of logistic regression model test statistics has 4 columns contrast, degrees of freedom, Wald chi-square and p-value for Wald chi-sqaure
for each row of overall model, model minus intercept variable, intercept variable, followed by each independant variable"
        class="table table-bordered"
    >
        <tbody>
            <tr>
                <th scope="col" align="center">Contrast</th>
                <th scope="col" align="center">Degrees of<br />Freedom</th>
                <th scope="col" align="center">Wald<br />chi-square</th>
                <th scope="col" align="center">
                    p-value for<br />Wald chi-square
                </th>
            </tr>
            <model-test-statistic-row
                variableTitle="Overall Model"
                :statistics="reportModel.OverallModel"
            ></model-test-statistic-row>
            <model-test-statistic-row
                variableTitle="Model minus intercept"
                :statistics="reportModel.ModelMinusIntercept"
            ></model-test-statistic-row>
            <model-test-statistic-row
                variableTitle="Intercept"
                :statistics="reportModel.Intercept"
            ></model-test-statistic-row>
            <template
                v-for="(v, variableIndex) in independentVariables"
            >
                <model-test-statistic-row  v-bind:key="v.variable.variable"
                    :variableTitle="v.variable.variableTitle"
                    :statistics="
                        reportModel['variable_ind' + (variableIndex + 1)]
                    "
                ></model-test-statistic-row>
            </template>
        </tbody>
    </table>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import modelTestStatisticRow from '@/components/logisticRegression/report/modelTestStatisticRow';

export default {
    props: ['reportModel', 'independentVariables'],
    data: function () {
        var vm = this;
        return {};
    },
    components: {
        'model-test-statistic-row': modelTestStatisticRow
    },
    methods: {}
};
</script>

<style scoped>
</style>
